import { api, setSession, ApiError } from "../api.js";

export function renderLogin (root: HTMLElement, onSuccess: () => void): void {
    const card = document.createElement ("sl-card");
    const stack = document.createElement ("div");
    stack.className = "stack";

    const title = document.createElement ("h2");
    title.textContent = "trackme — Anmelden";
    stack.appendChild (title);

    const email = document.createElement ("sl-input");
    email.setAttribute ("label", "Email");
    email.setAttribute ("type", "email");
    email.setAttribute ("autocomplete", "username");
    email.setAttribute ("required", "");

    const password = document.createElement ("sl-input");
    password.setAttribute ("label", "Passwort");
    password.setAttribute ("type", "password");
    password.setAttribute ("password-toggle", "");
    password.setAttribute ("autocomplete", "current-password");
    password.setAttribute ("required", "");

    const error = document.createElement ("div");
    error.className = "error";

    const submit = document.createElement ("sl-button");
    submit.setAttribute ("variant", "primary");
    submit.textContent = "Anmelden";

    async function attemptLogin (): Promise<void> {
        const e = (email as unknown as { value: string }).value.trim ();
        const p = (password as unknown as { value: string }).value;

        if (e === "" || p === "") {
            error.textContent = "Email und Passwort erforderlich";
            return;
        }

        submit.setAttribute ("loading", "");
        error.textContent = "";

        try {
            const r = await api.login (e, p);
            setSession (r.token, r.display_name, r.email);
            onSuccess ();
        }
        catch (err) {
            const msg = (err instanceof ApiError) ? err.message : "Fehler beim Anmelden";
            error.textContent = msg;
        }
        finally {
            submit.removeAttribute ("loading");
        }
    }

    submit.addEventListener ("click", () => { void attemptLogin (); });

    [email, password].forEach (input => {
        input.addEventListener ("keydown", (ev: Event) => {
            if ((ev as KeyboardEvent).key === "Enter") {
                void attemptLogin ();
            }
        });
    });

    stack.appendChild (email);
    stack.appendChild (password);
    stack.appendChild (error);
    stack.appendChild (submit);

    card.appendChild (stack);
    root.appendChild (card);
}
